import React, { useState, useEffect } from 'react';

const PHONE_HREF = 'tel:+48536030706';
const WHATSAPP_HREF = 'https://wa.me/48536030706?text=Dzień%20dobry%2C%20chciałbym%2Fm%20zapytać%20o%20wynajem%20Infiniti%20FX35.';

export default function MobileCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <div
      className="md:hidden"
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 400,
        padding: '12px 16px',
        background: 'rgba(5,10,26,0.95)',
        backdropFilter: 'blur(20px)',
        borderTop: '1px solid rgba(59,130,246,0.15)',
        display: 'flex',
        gap: 10,
        transform: visible ? 'translateY(0)' : 'translateY(100%)',
        transition: 'transform 0.4s ease',
      }}
    >
      <a
        href={PHONE_HREF}
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 8,
          padding: '14px',
          borderRadius: 12,
          background: 'linear-gradient(135deg, #1a3460, #3b82f6)',
          color: '#f4f5f7',
          textDecoration: 'none',
          fontSize: 14,
          fontWeight: 600,
          boxShadow: '0 4px 20px rgba(59,130,246,0.4)',
        }}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.01 1.22 2 2 0 012 0h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.09 7.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 14z" />
        </svg>
        Zadzwoń
      </a>

      <a
        href={WHATSAPP_HREF}
        target="_blank"
        rel="noopener noreferrer"
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 8,
          padding: '14px',
          borderRadius: 12,
          border: '1px solid rgba(59,130,246,0.4)',
          color: '#60a5fa',
          textDecoration: 'none',
          fontSize: 14,
          fontWeight: 600,
        }}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zM12 0C5.373 0 0 5.373 0 12c0 2.098.546 4.067 1.5 5.785L0 24l6.37-1.47A11.942 11.942 0 0012 24c6.627 0 12-5.373 12-12S18.627 0 12 0zm0 22c-1.846 0-3.574-.476-5.077-1.312l-.363-.215-3.782.872.891-3.682-.237-.38A9.97 9.97 0 012 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10z" />
        </svg>
        WhatsApp
      </a>
    </div>
  );
}
